import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import ActionBarButton from '../../_partials/ActionBarButton';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import AddToGroup from '../../../Icons/AddToGroup';
import { BiDataHook, BiEventType } from '@wix/da-bi/pkg/constants';
import { useCustomNotifications } from '../../../Notifications/CustomNotificationContext';
import { NotificationType } from '../../../Notifications';
import ActionBarItemWrapper from '../../_partials/ActionBarButton/ActionBarItemWrapper';
import ActionBarToggleButton from '../../_partials/ActionBarButton/ActionBarToggleButton';
var notificationTypes = [
    NotificationType.AddToGroup,
    NotificationType.GroupPrompt,
];
export var AddToGroupButton = function (_a) {
    var activated = _a.activated, withTooltip = _a.withTooltip, deviation = _a.deviation, onClick = _a.onClick;
    var isActionBarButtonRefactorFlagEnabled = useFlag('actionbar_button_refactor');
    var t = useTranslation().t;
    var notifications = useCustomNotifications(notificationTypes).notifications;
    var isShowingTooltip = withTooltip && !notifications.length;
    var tooltipText = isShowingTooltip ? t('actionbar.addToGroup') : undefined;
    return isActionBarButtonRefactorFlagEnabled ? (React.createElement(ActionBarItemWrapper, { tooltip: tooltipText, notificationTypes: notificationTypes },
        React.createElement(ActionBarToggleButton, { activated: activated, onClick: onClick, dataHook: BiDataHook.DEVIATION_GROUPS_COUNTER, biData: {
                evid: BiEventType.ADD_TO_GROUP_CLICK,
                deviationid: deviation.deviationId,
                sectionname: 'add_to_group',
            }, icon: AddToGroup }))) : (React.createElement(ActionBarButton, { onClick: onClick, dataHook: BiDataHook.DEVIATION_GROUPS_COUNTER, tooltip: tooltipText, biData: {
            evid: BiEventType.ADD_TO_GROUP_CLICK,
            deviationid: deviation.deviationId,
            sectionname: 'add_to_group',
        }, notificationTypes: notificationTypes },
        React.createElement(ActionBarIcon, { icon: AddToGroup })));
};
AddToGroupButton.displayName = 'AddToGroupButton';
export default AddToGroupButton;
//# sourceMappingURL=AddToGroupButton.js.map